    $(document).ready(function () {
      	$("#content-slider").lightSlider({
				loop:true,
				keyPress:true
			});
			$('#image-gallery').lightSlider({
				gallery:true,
				item:1,
				thumbItem:4,
				slideMargin: 15,
				speed:500,
				auto:false,
				loop:true,
				onSliderLoad: function() {
					$('#image-gallery').removeClass('cS-hidden');
				}  
			});
        $('#tags').autocomplete({
            source: function (request, response) {
                fetch('/search/suggest.json?q=' + request.term)
                    .then((response) => response.json())
                    .then((suggestions) => {
                        const productSuggestions = suggestions.resources.results.products;
                        if (productSuggestions.length > 0) {
                            const formattedSuggestions = productSuggestions.map(product => ({
                                label: product.title,
                                value: product.url
                            }));
                            response(formattedSuggestions);
                        } else {
                            response([]); // No suggestions
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching suggestions:', error);
                        response([]); // Handle errors
                    });
            },
            minLength: 3,
            select: function (event, ui) {
                // Redirect to the selected URL
                window.location.href = ui.item.value;
            }
        }).data("ui-autocomplete")._renderItem = function (ul, item) {
            return $("<li>")
                .append("<a href='" + item.value + "'>" + item.label + "</a>")
                .appendTo("#search-results");
        };
    });
$('.owl-carousel').owlCarousel({
    loop:true,
    margin:15,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
});
$(window).scroll(function(){
  if ($(this).scrollTop() > 50) {
     $('#dynamic').addClass('newClass');
  } else {
     $('#dynamic').removeClass('newClass');
  }
});
$("#search").click(function() {
  $(".search-bar").css("display","block");
});
$("#search-mob").click(function() {
  $(".search-bar").css("display","block");
});
$("a.crs-btn").click(function() {
    $(".search-bar").css("display","none");
});

